<template>
  <div class="identify">
    <div class="img-list" v-if="subtopicInfo.content" :class="[`num${subtopicInfo.content.length}`,{flip: flipStatus, random: subtopicInfo.a_way * 1 === 2 && subtopicInfo.content.length > 3}]">
      <div class="img-item" :class="{active: getSelectedStatus('image', index)}" v-for="(item, index) in subtopicInfo.content" :key="index" @click="imageSelect(item, index)">
        <img :src="item.img_url" alt=""></img>
      </div>
    </div>
    <div class="options" v-if="subtopicInfo.type * 1 === 2">
      <div class="option-item" :class="{active: getSelectedStatus('option', item.key)}" v-for="(item, index) in subtopicInfo.many.option" :key="item.key" @click="optionSelect(item, index)">{{ item.content }}</div>
    </div>
    <div class="flip-btn" @click="flip">
      <img src="@/assets/img/btn-flip.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "Identify",
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    subtopicInfo: {
      type: Object,
      required: true
    },
    originalSubtopicInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      flipStatus: false,
      answer: "",
      answerRecord: [],
    }
  },
  watch: {
    value: {
      handler(val) {
        this.answer = val;
      },
      immediate: true
    },
    subtopicInfo: {
      handler(val) {
        if (this.originalSubtopicInfo.is_rec * 1 === 1) {
          this.answer = this.originalSubtopicInfo.rec_answer * 1;
          this.$emit('input', this.answer);
          this.$set(this, 'answerRecord', this.originalSubtopicInfo.rec_option);
        }
        if (val.a_way * 1 === 2 && val.content && val.content.length > 3) {
          this.$nextTick(() => {
            this.randomLayout()
          })
        }
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('resize', this.randomLayout);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.randomLayout);
  },
  methods: {
    randomLayout() {
      this.$nextTick(() => {
        const container = this.$el.querySelector('.img-list');
        const items = Array.from(container.querySelectorAll('.img-item'));
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;
        const margin = 10; // 图片之间的边距（单位：px）

        // 获取所有图片的实际尺寸
        const itemSizes = items.map(item => ({
          width: item.offsetWidth,
          height: item.offsetHeight
        }));

        // 计算最大图片尺寸，用于确定网格大小
        const maxItemWidth = Math.max(...itemSizes.map(s => s.width)) + margin * 2;
        const maxItemHeight = Math.max(...itemSizes.map(s => s.height)) + margin * 2;

        // 计算可放置的网格数量
        const cols = Math.floor(containerWidth / maxItemWidth);
        const rows = Math.floor(containerHeight / maxItemHeight);

        // 生成所有网格坐标
        const grid = [];
        for (let row = 0; row < rows; row++) {
          for (let col = 0; col < cols; col++) {
            const x = col * maxItemWidth + margin;
            const y = row * maxItemHeight + margin;
            grid.push({ x, y });
          }
        }

        // 随机打乱网格顺序
        const shuffledGrid = this.shuffleArray(grid);

        // 分配图片位置
        items.forEach((item, index) => {
          if (index < shuffledGrid.length) {
            const pos = shuffledGrid[index];
            const offsetX = Math.random() * 5 - 2.5;
            const offsetY = Math.random() * 5 - 2.5;
            item.style.left = (pos.x + offsetX) + 'px';
            item.style.top = (pos.y + offsetY) + 'px';
          }
        });
      })
    },
    // 随机打乱数组
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    flip() {
      this.flipStatus = !this.flipStatus
    },
    imageSelect(item, index) {
      if (this.subtopicInfo.type * 1 === 1 && this.subtopicInfo.is_auto * 1 === 1) {
        // 判断是否存在该项，存在则删除，否则添加
        let existIndex = this.answerRecord.findIndex(i => i.index * 1 === index)
        if (existIndex !== -1) {
          this.answerRecord.splice(existIndex, 1)
        } else {
          this.answerRecord.push(item)
        }
        this.calculateAnswer()
      }
    },
    getSelectedStatus(type, value) {
      if (type === 'image') {
        return this.answerRecord.some(v => v.index * 1 === value);
      }
      if (type === 'option') {
        return this.answerRecord.some(v => v.key * 1 === value * 1);
      }
    },
    optionSelect(item, index) {
      let existIndex = this.answerRecord.findIndex(i => i.key * 1 === item.key * 1)
      if (existIndex !== -1) {
        this.answerRecord.splice(existIndex, 1)
      } else {
        this.answerRecord.push(item)
      }
      this.calculateAnswer()
    },
    // 计算分数
    calculateAnswer() {
      if (this.answerRecord.length === 0) {
        this.answer = '';
      } else {
        if (this.subtopicInfo.type * 1 === 1) {
          let correct = this.subtopicInfo.content.filter(v => v.type * 1 === 1)
          let isAllCorrect = this.answerRecord.every(v => correct.some(v2 => v2.index * 1 === v.index * 1))
          if (correct.length === this.answerRecord.length && isAllCorrect) {
            this.answer = 1;
          } else {
            this.answer = 0;
          }
        }
        if (this.subtopicInfo.type * 1 === 2) {
          let correct = this.subtopicInfo.many.answer
          let isAllCorrect = this.answerRecord.every(v => correct.some(v2 => v2.key * 1 === v.key * 1))
          if (correct.length === this.answerRecord.length && isAllCorrect) {
            this.answer = 1;
          } else {
            this.answer = 0;
          }
        }
      }
      this.$emit('input', this.answer);
    },
  },
}
</script>

<style lang="less" scoped>
.identify {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .img-list {
    width: 100%;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
    position: relative;
    &.flip {
      transform: rotate(180deg);
    }
    .img-item {
      width: 2.6rem;
      height: 2.6rem;
      border-radius: 0.15rem;
      overflow: hidden;
      font-size: 0;
      &.active {
        border: 0.02rem dashed #ffb453;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &.num2 {
      .img-item {
        width: 2.6rem;
        height: 2.6rem;
        margin: 0 0.17rem;
      }
    }
    &.num3 {
      .img-item {
        width: 2rem;
        height: 2rem;
        margin: 0 0.15rem;
      }
    }
    &.num4 {
      .img-item {
        width: 2rem;
        height: 2rem;
        margin: 0 0.08rem 0.16rem;
      }
    }
    &.num5:not(.random) {
      .img-item {
        width: 1.6rem;
        height: 1.6rem;
        margin: 0 0.08rem 0.16rem;
      }
    }
    &.num6:not(.random) {
      width: 5.1rem;
      .img-item {
        width: 1.3rem;
        height: 1.3rem;
        margin: 0 0.05rem 0.1rem;
      }
      .img-item:nth-child(n + 4) {
        margin-bottom: 0;
      }
    }
    &.num7:not(.random),
    &.num8:not(.random) {
      width: 6rem;
      .img-item {
        width: 1.3rem;
        height: 1.3rem;
        margin: 0 0.05rem 0.1rem;
      }
      .img-item:nth-child(n + 5) {
        margin-bottom: 0;
      }
    }
    &.num9:not(.random),
    &.num10:not(.random) {
      width: 7rem;
      .img-item {
        width: 1.3rem;
        height: 1.3rem;
        margin: 0 0.05rem 0.1rem;
      }
      .img-item:nth-child(n + 6) {
        margin-bottom: 0;
      }
    }
    &.random {
      display: block;
      .img-item {
        position: absolute;
      }
      &.num5 .img-item,
      &.num6 .img-item {
        width: 1.3rem;
        height: 1.3rem;
      }
      &.num7 .img-item,
      &.num8 .img-item,
      &.num9 .img-item,
      &.num10 .img-item {
        width: 1rem;
        height: 1rem;
      }
    }
  }
  .options {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background: linear-gradient(124deg, #fff6e5 0%, #ffebd4 100%);
    box-shadow: 0 0.03rem 0.06rem 1px rgba(216, 130, 0, 0.38);
    border-radius: 0.16rem;
    border: 1px dashed #ffb453;
    padding: 0.06rem;
    margin-top: 0.2rem;
    .option-item {
      width: 15.3%;
      line-height: 0.3rem;
      border-radius: 0.15rem;
      text-align: center;
      background: #fff;
      font-size: 0.14rem;
      color: #630200;
      margin: 0 0.6%;
      &.active {
        background: linear-gradient(180deg, #ffe56f 0%, #ffd100 100%);
      }
    }
  }
  .flip-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.28rem;
    height: 0.28rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>